import styled from 'styled-components'

const StyledCaptionsView = styled.div`
  height: 100%;
  overflow-y: auto;
`

export default StyledCaptionsView
